import { render, staticRenderFns } from "./AppRiskConfigSidebar.vue?vue&type=template&id=7de04107&"
import script from "./AppRiskConfigSidebar.vue?vue&type=script&lang=js&"
export * from "./AppRiskConfigSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports